// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

//import axios from 'axios';
//import Inputmask from 'inputmask';
//import { register } from 'swiper/swiper-element-bundle.mjs';

//import 'swiper/css/effect-fade';
import SliderPhoto from '@/components/slider-photo';

import catalog from '@/mixins/catalog';
import swiperCustom from "@/components/swiper-custom";


//const axios = () => import ('axios');
import oneComplex from '@/components/one-complex';

//const oneHome = () => import ('@/components/one-home');
import oneHome from '@/components/one-home';
//const oneProject = () => import ('@/components/one-project');
import oneProject from '@/components/one-project';
const oneArea = () => import ('@/components/one-area');

//import pagination from '@/components/pagination';
const pagination = () => import ('@/components/pagination');


// import vueBox from '@/components/vuebox';
// import vueboxGallery from '@/components/vuebox-gallery';

//const VModal = () => import ('vue-js-modal');
const vueBox = () => import ('@/components/vuebox');
const vueboxGallery = () => import ('@/components/vuebox-gallery');

//import oneArea from '@/components/one-area';
import progressBullets from '@/components/progress-bullets';
//import VueSlider from 'vue-slider-component';
const VueSlider = () => import ('vue-slider-component');
import 'vue-slider-component/theme/default.css';
const leaflet = () => import ('@/components/leaflet');




//import VueSlick from 'vue-slick';
//console.log(ROOT_DIR);

/* eslint-disable no-new */
// if(document.getElementById("vue-example")) {
//     const Example = require('./Example').default;

//     Vue.config.productionTip = false;

//     new Vue({
//         el: '#vue-example',
//         components: {Example},
//         template: '<Example/>',
//     });
// }






function formatData(number){

  let floatNum = parseFloat(number);

  
  if(floatNum < 1000)
  {
    return String(floatNum);
  }
  else
  {
    return floatNum.toLocaleString('ru');
  }
  
}


// Wait for Vue to be available from vendor.js
if (typeof window.Vue === 'undefined') {
    console.error('Vue is not loaded! Make sure vendor.js loads before custom.js');
}

const Vue = window.Vue;

Vue.directive('numflip', {
       
  bind: function(el, binding) {
    //el.setAttribute("value", parseFloat(binding.value).toLocaleString('ru'));
    el.value = formatData(binding.value);
  },
  update: function (el, binding, vnode) {
    var numberAnimation = function(el, oldValue, newValue) {
      var start = null, duration = 200
      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = timestamp - start;
        el.value = formatData(Math.round(oldValue + (newValue-oldValue)*progress/duration));
       // el.setAttribute("value", Math.round(oldValue + (newValue-oldValue)*progress/duration).toLocaleString('ru'));
        
        if (progress < duration) {
          window.requestAnimationFrame(step);
        } else {
          el.value = formatData(newValue);
          //el.setAttribute("value", newValue.toLocaleString('ru'));ы
        }
      }
      el.value =  formatData(oldValue);
      //el.setAttribute("value", oldValue.toLocaleString('ru'));
      window.requestAnimationFrame(step);
    };
   
    let value_input = parseFloat(el.value.replace(/[^\.\d]/g, ''));
   
   
    if((parseFloat(binding.value) != value_input || parseFloat(binding.value) != parseFloat(binding.oldValue)) && binding.value !== false) {

      
      //el.setAttribute("value", binding.value.toLocaleString('ru'));
      //console.log(el);
      numberAnimation(el, binding.oldValue, binding.value)
    }
  }
});

window.bus = new Vue();

//console.log(window.global_vue);

// Vue.component('l-map', LMap);
// Vue.component('l-tile-layer', LTileLayer);
// Vue.component('l-marker', LMarker);
// Vue.component('l-polygon', LPolygon);
// Vue.component('l-image-overlay', LImageOverlay);
// Vue.component('l-popup', LPopup);

//Vue.prototype.$L = L;
//Vue.component('L', L);

//Vue.use(FileUpload);



if(typeof window.global_vue !== 'undefined')
{
    
  
    window.global_vue.forEach(function(item, index, array) {

        item["mixins"] = [catalog];
        item["components"] = {//"file-upload":FileUpload, 
                              "slider-photo": SliderPhoto,
                              "pagination":pagination,
                              "vuebox":vueBox,
                              "vuebox-gallery":vueboxGallery,
                              "one-complex":oneComplex,
                              "one-home":oneHome,
                              "one-project":oneProject,
                              "one-area":oneArea,
                              "progress-bullets": progressBullets,
                              "vue-slider":VueSlider,
                              "swiper-custom": swiperCustom,
                              //"yandex-plan":YandexPlan,
                              "leaflet":leaflet
                            };
       // console.log(item);

      //  if()
      //  {
      //   item["components"][""]
      //  }

        // try/catch: Safari/WebKit бросает InvalidCharacterError на
        // setAttribute('@click') в v-pre-поддереве (см. gallery_grid) и ронял
        // весь forEach — из-за одной галереи не монтировались блоки ниже
        try {
            new Vue(item);
        } catch (e) {
            console.error('Vue mount failed for ' + (item && item.el), e);
        }

  });


    window.global_vue = [];


    
}